import React from 'react';
import styles from './Spinner.module.css';

function Spinner() {
    return (
        <div className={styles.container}>
            <div className={styles.spinner}>

                    <div className={styles.circleBorder}>
                        <div className={styles.circleCore}></div>
                    </div>  

            </div>
        </div>
    )
}

export default Spinner;
